module.exports = ".dynamic-pages-wrapper {\n  width: 80%;\n  margin: 0 auto;\n  margin-top: 245px;\n  margin-bottom: 50px; }\n"